//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'base-fields-array',
  model: {
    prop: 'list',
    emit: 'change',
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    long: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: [String, Object, null],
      default: '',
    },
    canRemoveFirst: {
      type: Boolean,
      default: false,
    },
    canRemoveItem: {
      type: Function,
      default: () => true,
    },
    label: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default: '',
    },
    isError: {
      type: Boolean,
      default: false,
    },
    maxCount: {
      type: [Number, String],
      default: '',
    },
    keyProperty: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noEnter: {
      type: Boolean,
      default: false,
    },
    manualRemove: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isRowView () {
      if (typeof this.defaultValue !== 'object') return true;
      return this.defaultValue && Object.keys(this.defaultValue).length === 1;
    },
    isLimitReached () {
      return !!this.maxCount && this.list.length >= +this.maxCount;
    },
  },
  methods: {
    addItem () {
      if (this.isLimitReached) return;
      // eslint-disable-next-line vue/no-mutating-props
      this.list.push(this.defaultValue);

      if (typeof this.defaultValue !== 'object') {
        this.$forceNextTick(() => {
          this.$refs.item[this.list.length - 1].querySelector('input')?.focus();
        });
      }
    },
    removeItem (index) {
      if (!this.canRemoveItem(this.list[index], index)) return;
      if (this.manualRemove) this.$emit('remove', index);
      // eslint-disable-next-line vue/no-mutating-props
      else this.list.splice(index, 1);
    },
  },
};
